import backArrow from "../../../images/Arrow.svg";
import React, {useContext} from "react";
import dataConnectorContext from './../context/dataConnectorContext'
import Description from "./Description";
const ConnectorHeader = ({children,title}) => {
    const context = useContext(dataConnectorContext)
    const goToBack = () => {
        let page = {
            'permissions': 'Assemble Input Source',
            'Upload File': 'Assemble Input Source',
            'Enter DB Info': 'permissions',
            'Select Event Log': 'Enter DB Info',
            'Zylem Connector': 'Assemble Input Source',
            'Source Preview': 'Upload File',
            'Data Preview': 'Generate Connector',
            'Add Columns': 'Data Preview',
            'Load Data': 'Data Preview',
            'Generate Connector': 'Upload File',
        };
        console.log('back',page[context.state.page])
        context.dispatch({type:'set_page',value:page[context.state.page]})
    }
    return(
        <>
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex">
                    <img src={backArrow} onClick={() => goToBack()} className="mr-32 pointer"/>
                    <p className="f20 fw500 dark-gary-2">{title}</p>
                </div>
            </div>
            <Description>{children}</Description>
        </>
    )
}
export default ConnectorHeader;